/** localStorage mit try/catch – Private Mode / blockierter Speicher darf nichts kaputt machen. */
const PREFIX = 'bs.';

export function load(key, fallback) {
  try {
    const raw = window.localStorage.getItem(PREFIX + key);
    return raw == null ? fallback : JSON.parse(raw);
  } catch {
    return fallback;
  }
}

export function save(key, value) {
  try {
    if (value === undefined || value === null) window.localStorage.removeItem(PREFIX + key);
    else window.localStorage.setItem(PREFIX + key, JSON.stringify(value));
  } catch { /* ignorieren */ }
}

/** Zuletzt geöffnete Aufträge (max. 8). */
export function rememberAuftrag(a) {
  const list = load('recent', []).filter((x) => x.nummer !== a.nummer);
  save('recent', [{ nummer: a.nummer, titel: a.titel, ort: a.kunde?.ort ?? '', firma: a.kunde?.firma ?? '' }, ...list].slice(0, 8));
}
export const recentAuftraege = () => load('recent', []);

/**
 * Benutzerbezogene Daten dieses Geräts löschen (beim Abmelden oder Benutzerwechsel).
 * Der zuletzt verwendete Benutzername (und Firmen-Code) bleibt, damit die Anmeldung schneller geht.
 * `firmenwechsel`: auch Artikelstamm und -bilder weg – sie gehören zur bisherigen Firma.
 */
export function clearUserData({ firmenwechsel = false } = {}) {
  try {
    // bleibt: Benutzername, Firmen-Code und der Artikelstamm der Firma (Stammdaten, nicht personenbezogen)
    const keep = new Set([`${PREFIX}benutzer`, `${PREFIX}firma`, ...(firmenwechsel ? [] : [`${PREFIX}artikelkatalog`, `${PREFIX}mandant`])]);
    for (const k of Object.keys(window.localStorage)) {
      if (k.startsWith(PREFIX) && !keep.has(k)) window.localStorage.removeItem(k);
    }
  } catch { /* ignorieren */ }
}

/** Artikelbilder der bisherigen Firma vom Gerät entfernen (Service-Worker-Cache). */
export async function artikelbilderLoeschen() {
  try { if (typeof caches !== 'undefined') await caches.delete('artikelbilder-v1'); } catch { /* ignorieren */ }
}
